import React from 'react';
import * as Panel2 from './panel';

const inputType = null;
type PanelNullProps = Panel2.PanelProps<typeof inputType>;

const PanelNull: React.FC<PanelNullProps> = props => <div>-</div>;

export const Spec: Panel2.PanelSpec = {
  id: 'null',
  Component: PanelNull,
  inputType,
};
